import React, { ReactNode } from "react";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import { AppIcon } from "../../Generic/AppIcon";
import Flex from "../../Generic/Flex";

interface Props {
  icon: JSX.Element;
  label: ReactNode;
  value: ReactNode;
}

const PatientVitalCard = (props: Props) => {
  return (
    <AppCard className="PatientVitalCard">
      <AppCardContent>
        <Flex direction="column" yGap={6}>
          <Flex xGap={8} alignItems="center">
            <AppIcon icon={props.icon} size={24} />
            <strong className="__value">{props.value}</strong>
          </Flex>
          <strong className="__label">{props.label}</strong>
        </Flex>
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(PatientVitalCard);
